module.exports = __webpack_public_path__ + "img/hero_image_strong_together_mobile.640632c.jpg";